import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchData } from '../../Utils/Server';
import Endpoints from '../../Constants/Endpoints';
import PageLayout from '../Layout/PageLayout';
import { DataTable, Card, Tabs, StatusBadge } from '../UI';

const hasDoc = (row, k) => {
  const r = row.rider || row;
  return r[k] ? '✓' : '—';
};

const columns = [
  {
    name: 'Name',
    cell: (row) => {
      const r = row.rider || row;
      return <Link to={`/rider-vetting/${r.id}`}>{r.name || '(unnamed)'}</Link>;
    },
  },
  { name: 'Phone', cell: (row) => (row.rider || row).phone },
  { name: 'DL', cell: (row) => hasDoc(row, 'dl_doc_url') },
  { name: 'Good Conduct', cell: (row) => hasDoc(row, 'good_conduct_url') },
  { name: 'NHIF/NSSF', cell: (row) => hasDoc(row, 'nhif_nssf_url') },
  { name: 'Next of Kin', cell: (row) => hasDoc(row, 'next_of_kin_json') },
  {
    name: 'Status',
    cell: (row) => {
      const s = (row.rider || row).vetting_status || 'pending';
      const tone = s === 'approved' ? 'success' : s === 'rejected' ? 'danger' : 'neutral';
      return <StatusBadge tone={tone}>{s.toUpperCase()}</StatusBadge>;
    },
  },
];

const TABS = [
  { key: 'pending', label: 'Pending' },
  { key: 'approved', label: 'Approved' },
  { key: 'rejected', label: 'Rejected' },
];

export default function PendingList() {
  const [status, setStatus] = useState('pending');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchData(`${Endpoints.LIST_PENDING_RIDERS}?status=${status}`)
      .then((res) => res.json())
      .then((res) => {
        setRows(res.riders || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [status]);

  return (
    <PageLayout title="Rider vetting">
      <Tabs value={status} onChange={setStatus} tabs={TABS} />
      <Card padded={false}>
        <DataTable
          columns={columns}
          data={rows}
          progressPending={loading}
          noHeader={true}
        />
      </Card>
    </PageLayout>
  );
}
